<template>
  <component :is="tagName" :class="classes" v-bind="dynamicProperties">
    <div class="vl-doormat__content">
      <span class="vl-doormat__content__arrow" aria-hidden="true"></span>
      <h2 v-if="title" class="vl-doormat__title" data-vl-clamp="2">
        {{ title }}
      </h2>
      <div v-if="$slots.default" class="vl-doormat__text">
        <slot></slot>
      </div>
    </div>
  </component>
</template>
<script src="./dl-doormat.ts"></script>
